import axios from "axios";
import { toast } from "react-hot-toast";

export const FETCH_DESIGNATIONS_REQUEST = "FETCH_DESIGNATIONS_REQUEST";
export const FETCH_DESIGNATIONS_SUCCESS = "FETCH_DESIGNATIONS_SUCCESS";
export const FETCH_DESIGNATIONS_FAILURE = "FETCH_DESIGNATIONS_FAILURE";

export const fetchDesignations = () => async (dispatch) => {
  dispatch({ type: FETCH_DESIGNATIONS_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/getAllDesignations`,
      {
        headers: {
          Authorization: token,
        },
      },
    );

    dispatch({
      type: FETCH_DESIGNATIONS_SUCCESS,
      payload: res.data.data, // array of strings
    });
  } catch (error) {
    dispatch({
      type: FETCH_DESIGNATIONS_FAILURE,
      payload: error?.response?.data?.meta?.message || error.message,
    });
  }
};

export const CREATE_DESIGNATION_REQUEST = "CREATE_DESIGNATION_REQUEST";
export const CREATE_DESIGNATION_SUCCESS = "CREATE_DESIGNATION_SUCCESS";
export const CREATE_DESIGNATION_FAILURE = "CREATE_DESIGNATION_FAILURE";

export const createDesignation = (data) => async (dispatch) => {
  dispatch({ type: CREATE_DESIGNATION_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/createDesignation`,
      data,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      },
    );

    dispatch({ type: CREATE_DESIGNATION_SUCCESS, payload: response.data.data });
    toast.success(
      response.data?.meta?.message || "Designation created successfully",
    );
  } catch (error) {
    const errorMsg = error.response?.data?.meta?.message || error.message;
    dispatch({ type: CREATE_DESIGNATION_FAILURE, payload: errorMsg });
    toast.error(errorMsg);
  }
};

// ============================
// ADMIN DESIGNATION ACTIONS
// ============================

export const FETCH_ADMIN_DESIGNATIONS_REQUEST =
  "FETCH_ADMIN_DESIGNATIONS_REQUEST";
export const FETCH_ADMIN_DESIGNATIONS_SUCCESS =
  "FETCH_ADMIN_DESIGNATIONS_SUCCESS";
export const FETCH_ADMIN_DESIGNATIONS_FAILURE =
  "FETCH_ADMIN_DESIGNATIONS_FAILURE";

// API: /v1/api/getAllDesignationsAdmin
export const fetchAdminDesignations = () => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_DESIGNATIONS_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/getAllDesignationsAdmin`,
      {
        headers: {
          Authorization: token,
        },
      },
    );

    dispatch({
      type: FETCH_ADMIN_DESIGNATIONS_SUCCESS,
      payload: res.data.data, // array of {id, name}
    });
  } catch (error) {
    dispatch({
      type: FETCH_ADMIN_DESIGNATIONS_FAILURE,
      payload: error?.response?.data?.meta?.message || error.message,
    });
  }
};

// // redux/actions/designationActions.js
// import axios from "axios";
// import { toast } from "react-hot-toast";

// // =============================
// // FETCH NORMAL DESIGNATIONS
// // =============================
// export const FETCH_DESIGNATIONS_REQUEST = "FETCH_DESIGNATIONS_REQUEST";
// export const FETCH_DESIGNATIONS_SUCCESS = "FETCH_DESIGNATIONS_SUCCESS";
// export const FETCH_DESIGNATIONS_FAILURE = "FETCH_DESIGNATIONS_FAILURE";

// export const fetchDesignations = () => async (dispatch) => {
//   dispatch({ type: FETCH_DESIGNATIONS_REQUEST });

//   try {
//     const token = localStorage.getItem("token");
//     const res = await axios.get(
//       `${process.env.REACT_APP_API_BASE_URL}/v1/api/getAllDesignations`,
//       {
//         headers: { Authorization: token },
//       }
//     );

//     dispatch({
//       type: FETCH_DESIGNATIONS_SUCCESS,
//       payload: res.data.data,
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_DESIGNATIONS_FAILURE,
//       payload: error?.response?.data?.meta?.message || error.message,
//     });
//   }
// };

// // =============================
// // CREATE DESIGNATION
// // =============================
// export const CREATE_DESIGNATION_REQUEST = "CREATE_DESIGNATION_REQUEST";
// export const CREATE_DESIGNATION_SUCCESS = "CREATE_DESIGNATION_SUCCESS";
// export const CREATE_DESIGNATION_FAILURE = "CREATE_DESIGNATION_FAILURE";

// export const createDesignation = (data) => async (dispatch) => {
//   dispatch({ type: CREATE_DESIGNATION_REQUEST });

//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.post(
//       `${process.env.REACT_APP_API_BASE_URL}/v1/api/createDesignation`,
//       data,
//       {
//         headers: {
//           Authorization: token,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     dispatch({
//       type: CREATE_DESIGNATION_SUCCESS,
//       payload: response.data.data,
//     });

//     toast.success(response.data?.meta?.message || "Designation created successfully");
//   } catch (error) {
//     const errorMsg = error.response?.data?.meta?.message || error.message;

//     dispatch({ type: CREATE_DESIGNATION_FAILURE, payload: errorMsg });
//     toast.error(errorMsg);
//   }
// };

// // =============================
// // FETCH ADMIN DESIGNATIONS
// // =============================
// export const FETCH_ADMIN_DESIGNATIONS_REQUEST = "FETCH_ADMIN_DESIGNATIONS_REQUEST";
// export const FETCH_ADMIN_DESIGNATIONS_SUCCESS = "FETCH_ADMIN_DESIGNATIONS_SUCCESS";
// export const FETCH_ADMIN_DESIGNATIONS_FAILURE = "FETCH_ADMIN_DESIGNATIONS_FAILURE";

// export const fetchAdminDesignations = () => async (dispatch) => {
//   dispatch({ type: FETCH_ADMIN_DESIGNATIONS_REQUEST });

//   try {
//     const token = localStorage.getItem("token");

//     const res = await axios.get(
//       `${process.env.REACT_APP_API_BASE_URL}/v1/api/getAllDesignationsAdmin`,
//       {
//         headers: { Authorization: token },
//       }
//     );

//     dispatch({
//       type: FETCH_ADMIN_DESIGNATIONS_SUCCESS,
//       payload: res.data.data, // [{id,name,status}]
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_ADMIN_DESIGNATIONS_FAILURE,
//       payload: error?.response?.data?.meta?.message || error.message,
//     });
//   }
// };

// // =============================
// // UPDATE DESIGNATION
// // =============================
// export const UPDATE_DESIGNATION_REQUEST = "UPDATE_DESIGNATION_REQUEST";
// export const UPDATE_DESIGNATION_SUCCESS = "UPDATE_DESIGNATION_SUCCESS";
// export const UPDATE_DESIGNATION_FAILURE = "UPDATE_DESIGNATION_FAILURE";

// export const updateDesignation = (id, data) => async (dispatch) => {
//   dispatch({ type: UPDATE_DESIGNATION_REQUEST });

//   try {
//     const token = localStorage.getItem("token");

//     const res = await axios.put(
//       `${process.env.REACT_APP_API_BASE_URL}/v1/api/updateDesignation/${id}`,
//       data,
//       {
//         headers: {
//           Authorization: token,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     dispatch({
//       type: UPDATE_DESIGNATION_SUCCESS,
//       payload: res.data.data,
//     });

//     toast.success(res.data?.meta?.message || "Designation updated successfully");

//     // refresh table
//     dispatch(fetchAdminDesignations());

//   } catch (error) {
//     const msg = error.response?.data?.meta?.message || error.message;

//     dispatch({ type: UPDATE_DESIGNATION_FAILURE, payload: msg });
//     toast.error(msg);
//   }
// };
